import SocialStrategyToken from './social_strategy'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Details extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { plan_type } = this.props.props
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { 
          label: 't(Previous)',
          color: 'blue',
          basic: true,
          disabled: true,
          handler: this._handleBack 
        },
        { 
          label: ['optin','diy'].includes(config.social_strategy) ? 't(Next)' : 't(Done)',
          color: 'blue',
          handler: this._handleSubmit 
        }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Social Media)',
              type: 'segment',
              fields: [
                { 
                  name: 'social_strategy',
                  type: 'radiogroup',
                  options: plan_type === 'essentials' ? ['diy','none'] : ['optin','optout'],
                  defaultValue: config.social_strategy || (plan_type === 'essentials' ? 'diy' : 'optin'),
                  format: SocialStrategyToken,
                  required: true 
                }
              ]
            }
          ] 
        }
      ]
    }
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    const { formdata, onNext, onSave } = this.props
    const action = ['optin','diy'].includes(config.social_strategy)  ? onNext : onSave
    action({
      ...formdata,
      ...config
    })
  }

}

export default Details
